import { render } from "./App.vue?vue&type=template&id=1b06a8dc&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1b06a8dc&lang=css"
import "./App.vue?vue&type=style&index=1&id=1b06a8dc&scoped=true&lang=less"

import exportComponent from "/home/runner/work/academic-pages/academic-pages/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b06a8dc"]])

export default __exports__